import React, { useCallback, useContext, useState } from 'react';
import { UiKit } from '@datavant/idsb-shared/uikit';
import { UserType } from '../../lib/contexts/UserType';
import { DebugPopoverFooter } from './DebugPopoverFooter';
import { DebugPopoverBody } from './DebugPopoverBody';
import { UserTypeContext } from '../../lib/contexts/UserTypeContext';

export const DebugMenu = (): JSX.Element => {
    const debugSettingsContext = useContext(UserTypeContext);
    const { isOpen, onToggle, onClose } = UiKit.Chakra.useDisclosure();
    const initialFocusRef = React.useRef<HTMLElement | null>(null);
    const [initial, setInitial] = useState<UserType>(debugSettingsContext.value);
    const [draft, setDraft] = useState<UserType>(debugSettingsContext.value);

    // @ts-ignore
    const onUserTypeChanged = useCallback(
        (user: UserType['user']) => {
            setDraft({
                ...draft,
                user: user,
            });
        },
        [setDraft, draft]
    );

    const onCancelClicked = useCallback(() => {
        onToggle();
        setDraft(initial);
    }, [onToggle, setDraft, initial]);

    const onApplyClicked = useCallback(() => {
        onToggle();
        setInitial({
            ...draft,
        });
        debugSettingsContext.setValue(draft);
    }, [debugSettingsContext, onToggle, setInitial, draft]);

    return (
        <UiKit.Chakra.Popover
            initialFocusRef={initialFocusRef}
            isOpen={isOpen}
            closeOnBlur={false}
            onClose={onClose}
            placement={'left'}
        >
            <UiKit.Chakra.PopoverTrigger>
                <UiKit.Chakra.Button
                    bgColor={'white'}
                    border={'none'}
                    _focus={{
                        border: 'none',
                    }}
                    _hover={{
                        bgColor: UiKit.consistency.primaryBlue10,
                    }}
                    size={'sm'}
                    onClick={onToggle}
                >
                    Debug
                </UiKit.Chakra.Button>
            </UiKit.Chakra.PopoverTrigger>
            <UiKit.Chakra.PopoverContent
                bgColor={UiKit.consistency.white}
                border={`1px solid ${UiKit.consistency.gray10}`}
                borderRadius={UiKit.consistency.borderRadius}
                boxShadow={'0px 0px 20px rgba(17, 47, 78, 0.24)'}
                w={'auto'}
                minWidth={'500px'}
                mt={UiKit.consistency.halfBuffer}
                mr={UiKit.consistency.halfBuffer}
                color="white"
                ref={initialFocusRef}
                _focus={{
                    border: 'none',
                }}
            >
                <UiKit.Chakra.PopoverHeader fontWeight="bold" textColor={UiKit.consistency.gray70} border="0">
                    Debug Controls
                </UiKit.Chakra.PopoverHeader>
                <DebugPopoverBody decisionState={draft} onUserTypeChanged={onUserTypeChanged} />
                <DebugPopoverFooter onCancelClicked={onCancelClicked} onApplyClicked={onApplyClicked} />
            </UiKit.Chakra.PopoverContent>
        </UiKit.Chakra.Popover>
    );
};
